import { WebPlugin } from '@capacitor/core';
export class ZephyrDfuWeb extends WebPlugin {
    async updateFirmware(options, callback) {
        /// logic here
        console.log(options.fileURL, options.deviceIdentifier);
        callback('Web callback');
        return ``;
    }
    async getVersion() {
        /// logic here
        return '';
    }
}
//# sourceMappingURL=web.js.map